export default __webpack_public_path__ + "static/bg-credit-score-c31b7b2d91d15b73a6f26dcc2867399d.jpg";